import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loginpage',
  templateUrl: './loginpage.component.html',
})
export class LoginpageComponent implements OnInit {
  initialLoadingFinished = false;
  isApp = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.loadScript('../assets/js/BEYAM5g3ZYkBxnx9bhxi.js');
  }

  loadScript(url: string) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
    this.isApp = this.router.url.indexOf('/app/') !== -1;
  }

  setLoadingFinished() {
    this.initialLoadingFinished = true;
  }
}
